export default "__VITE_ASSET__DQJUKity__"